module.exports = __webpack_public_path__ + "media/images/logo-eaecccf9.svg";